import React from 'react';
import { AppModule } from '../../core';
import { PublicLayout, DashboardLayout } from '../../core/layouts';
import { AppConfig } from '../../core/config';
import { AppEnvironments } from '../../core/constants';

const accountModule: AppModule = {
  routes: [
    {
      path: '/',
      exact: true,
      layout: PublicLayout,
      page: React.lazy(() => import('./pages/landing')),
    },
    {
      path: '/login',
      exact: true,
      layout: PublicLayout,
      page: React.lazy(() => import('./pages/login')),
    },
    {
      path: '/forgot-password',
      exact: true,
      layout: PublicLayout,
      page: React.lazy(() => import('./pages/forgot-password')),
    },
    {
      path: '/forgot-username',
      exact: true,
      layout: PublicLayout,
      page: React.lazy(() => import('./pages/forgot-username')),
    },
    {
      path: '/reset-password/',
      layout: PublicLayout,
      page: React.lazy(() => import('./pages/reset-password')),
    },
    {
      path: '/profile',
      exact: true,
      layout: DashboardLayout,
      page: React.lazy(() => import('./pages/profile')),
      permissions: [],
    },
    {
      path: '/timing-bolus-injection',
      exact: true,
      layout: DashboardLayout,
      page: React.lazy(() => import('./pages/timing-bolus-injection')),
      permissions: AppConfig.env === AppEnvironments.PRODUCTION ? ['Admin'] : [],
    },
  ],
};

export default accountModule;
